<template>
  <span v-if="asBackground" :style="style" class="h-80 bg-cover bg-no-repeat bg-center block max-w-md w-screen mb-2">&nbsp;</span>
  <img v-else :src="src" class="view-box max-h-80 cursor-pointer">
</template>

<script>
export default {
  name: 'ImageBackground',
  props: ['src'],
  emits: ['image-width'],
  created() {
    let self = this;
    const img = new Image();
    img.onload = function() {
      let ratio = this.width / this.height;
      self.asBackground = ratio < 0.5;

      let maxHeightStyle = 320;
      let factor = this.height / maxHeightStyle;
      let thumbWidth = this.width / factor;
      if (thumbWidth > 200 && thumbWidth < 600) {
        self.$emit('image-width', thumbWidth);
      }
    }
    img.src = this.src;
  },
  computed: {
    style() {
      return `background-image: url('${this.src}')`;
    }
  },
  data() {
    return {
      asBackground: false,
    }
  },
}
</script>
